/*
 * This class has been auto-generated by the back end. Look for usages of the library no.invarians.lib.es6facadegenerator.
 */
import {ApiClient} from 'api-client';
import {inject} from 'aurelia-framework';

@inject(ApiClient)
export default class Backend {
    apiClient;

    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Parameter dto:
     *     logLevel: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     nameSpace: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     secret: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     * Return dto:
     *     {
     *         value: '[char[]]',
     *         hash: '[int]',
     *         serialVersionUID: '[long]',
     *         serialPersistentFields: '[ObjectStreamField[]]',
     *         CASE_INSENSITIVE_ORDER: '[Comparator]'
     *     }
     */
    RestLogLevelController_logLevel(logLevel, nameSpace, secret) {
        return this.apiClient.invoke('RestLogLevelController', 'logLevel', { logLevel: logLevel, nameSpace: nameSpace, secret: secret });
    }

    /**
     * Parameter dto:
     *     personName: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    RestCheckInByPersonNameController_checkInQueryUrl(personName, eventId) {
        return this.apiClient.invoke('RestCheckInByPersonNameController', 'checkInQueryUrl', { personName: personName, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     invoiceId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    RestInvoiceAdminController_registerPayment(invoiceId) {
        return this.apiClient.invoke('RestInvoiceAdminController', 'registerPayment', { invoiceId: invoiceId });
    }

    /**
     * Parameter dto:
     *     ticketId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    RestInvoiceAdminController_cancelTicket(ticketId) {
        return this.apiClient.invoke('RestInvoiceAdminController', 'cancelTicket', { ticketId: ticketId });
    }

    /**
     * Parameter dto:
     *     ticketId: 
     *         {

     *         }
     *     note: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     * Return dto:
     *     void
     */
    RestInvoiceAdminController_addNote(ticketId, note) {
        return this.apiClient.invoke('RestInvoiceAdminController', 'addNote', { ticketId: ticketId, note: note });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         invoices: {
     *             invoiceId: '[InvoiceId]',
     *             dueDate: '[LocalDate]',
     *             ticketId: '[TicketId]',
     *             orderId: '[OrderId]',
     *             personId: '[PersonId]',
     *             amount: '[BigDecimal]',
     *             ticketStatus: '[TicketStatus]',
     *             paymentMethod: '[PaymentMethod]',
     *             ticketTypeId: '[TicketTypeId]',
     *             ticketTypeName: '[String]',
     *             reference: '[String]',
     *             daysUntilDueDate: '[long]',
     *             ticketNotes: {
     *                 dateTime: '[String]',
     *                 author: '[PersonId]',
     *                 message: '[String]'
     *             },
     *             seatNumber: '[String]'
     *         },
     *         persons: '[Map]'
     *     }
     */
    RestInvoiceAdminController_getInvoices(eventId) {
        return this.apiClient.invoke('RestInvoiceAdminController', 'getInvoices', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     logDto: 
     *         {
     *             logData: '[String]'
     *         }
     * Return dto:
     *     void
     */
    RestFrontEndLogController_register(logDto) {
        return this.apiClient.invoke('RestFrontEndLogController', 'register', { logDto: logDto });
    }

    /**
     * Parameter dto:
     *     ticketReference: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         tickets: {
     *             ticketId: '[TicketId]',
     *             ticketStatus: '[TicketStatus]',
     *             currentOwner: '[PersonId]',
     *             ticketTypeName: '[String]',
     *             seat: '[Optional]',
     *             reference: '[String]'
     *         },
     *         person: '[PersonDetailsDto]'
     *     }
     */
    RestCheckInByTicketReferenceQueryController_checkInQueryUrl(ticketReference, eventId) {
        return this.apiClient.invoke('RestCheckInByTicketReferenceQueryController', 'checkInQueryUrl', { ticketReference: ticketReference, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     ticketBuyerPersonId: 
     *         {

     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         seatMap: '[SeatMapDto]',
     *         ticketTypeMap: '[Map]',
     *         seatHolderNameMap: '[Map]',
     *         mySeats: {
     *             seatId: '[SeatId]',
     *             seatHolder: '[TicketId]',
     *             ticketStatus: '[TicketStatus]',
     *             ticketTypeId: '[TicketTypeId]',
     *             seatNumber: '[String]'
     *         }
     *     }
     */
    RestSeatMapController_getSeatMap(ticketBuyerPersonId, eventId) {
        return this.apiClient.invoke('RestSeatMapController', 'getSeatMap', { ticketBuyerPersonId: ticketBuyerPersonId, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         ticketsAvailableForTransfer: {
     *             ticketId: '[TicketId]',
     *             currentOwner: '[PersonId]',
     *             ticketStatus: '[TicketStatus]',
     *             ticketTypeId: '[TicketTypeId]',
     *             ticketTypeName: '[String]',
     *             seat: '[Optional]',
     *             firstName: '[String]',
     *             lastName: '[String]'
     *         },
     *         allPersons: {
     *             id: '[PersonId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             nickname: '[String]',
     *             birthDate: '[String]',
     *             email: '[String]',
     *             phoneNumber: '[PhoneNumberDto]'
     *         },
     *         this$0: '[RestGetTicketTransferDataController]'
     *     }
     */
    RestGetTicketTransferDataController_getTicketTransferData(eventId) {
        return this.apiClient.invoke('RestGetTicketTransferDataController', 'getTicketTransferData', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    RestGetAllParticipantsQueryController_getAllParticipants(eventId) {
        return this.apiClient.invoke('RestGetAllParticipantsQueryController', 'getAllParticipants', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     registerPersonDto: 
     *         {
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             birthDate: '[LocalDate]',
     *             email: '[String]',
     *             address: '[AddressDto]',
     *             phoneNumber: '[PhoneNumberDto]',
     *             guardian: '[GuardianDto]',
     *             nickname: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    SignUpController_signUp(registerPersonDto) {
        return this.apiClient.invoke('SignUpController', 'signUp', { registerPersonDto: registerPersonDto });
    }

    /**
     * Parameter dto:
     *     seatNumber: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         tickets: {
     *             ticketId: '[TicketId]',
     *             ticketStatus: '[TicketStatus]',
     *             currentOwner: '[PersonId]',
     *             ticketTypeName: '[String]',
     *             seat: '[Optional]',
     *             reference: '[String]'
     *         },
     *         person: '[PersonDetailsDto]'
     *     }
     */
    RestCheckInBySeatNumberQueryController_checkInQueryUrl(seatNumber, eventId) {
        return this.apiClient.invoke('RestCheckInBySeatNumberQueryController', 'checkInQueryUrl', { seatNumber: seatNumber, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             ticketId: '[TicketId]',
     *             seat: '[Optional]',
     *             ticketTypeId: '[TicketTypeId]',
     *             ticketTypeName: '[String]',
     *             ticketStatus: '[TicketStatus]',
     *             reference: '[String]'
     *         }
     *     }
     */
    GetMyTicketsQueryHandler_execute(query) {
        return this.apiClient.invoke('GetMyTicketsQueryHandler', 'execute', { query: query });
    }

    /**
     * Parameter dto:
     *     personId: 
     *         {

     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    CheckInByTicketOwnerPersonIdQueryHandler_query(personId, eventId) {
        return this.apiClient.invoke('CheckInByTicketOwnerPersonIdQueryHandler', 'query', { personId: personId, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     invoiceId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    TicketService_registerPayment(invoiceId) {
        return this.apiClient.invoke('TicketService', 'registerPayment', { invoiceId: invoiceId });
    }

    /**
     * Parameter dto:
     *     ticketId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    TicketService_cancelTicket(ticketId) {
        return this.apiClient.invoke('TicketService', 'cancelTicket', { ticketId: ticketId });
    }

    /**
     * Parameter dto:
     *     ticketId: 
     *         {

     *         }
     *     notat: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     * Return dto:
     *     void
     */
    TicketService_addNote(ticketId, notat) {
        return this.apiClient.invoke('TicketService', 'addNote', { ticketId: ticketId, notat: notat });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    TicketService_getAllInvoices(eventId) {
        return this.apiClient.invoke('TicketService', 'getAllInvoices', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    TicketService_getTicketTypes(eventId) {
        return this.apiClient.invoke('TicketService', 'getTicketTypes', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     ticketTypeId: 
     *         {

     *         }
     *     presaleStart: 
     *         {
     *             MIN: '[LocalDate]',
     *             MAX: '[LocalDate]',
     *             serialVersionUID: '[long]',
     *             DAYS_PER_CYCLE: '[int]',
     *             DAYS_0000_TO_1970: '[long]',
     *             year: '[int]',
     *             month: '[short]',
     *             day: '[short]'
     *         }
     *     presaleEnd: 
     *         {
     *             MIN: '[LocalDate]',
     *             MAX: '[LocalDate]',
     *             serialVersionUID: '[long]',
     *             DAYS_PER_CYCLE: '[int]',
     *             DAYS_0000_TO_1970: '[long]',
     *             year: '[int]',
     *             month: '[short]',
     *             day: '[short]'
     *         }
     *     presalePrice: 
     *         {
     *             intVal: '[BigInteger]',
     *             scale: '[int]',
     *             precision: '[int]',
     *             stringCache: '[String]',
     *             INFLATED: '[long]',
     *             INFLATED_BIGINT: '[BigInteger]',
     *             intCompact: '[long]',
     *             MAX_COMPACT_DIGITS: '[int]',
     *             serialVersionUID: '[long]',
     *             threadLocalStringBuilderHelper: '[ThreadLocal]',
     *             zeroThroughTen: '[BigDecimal[]]',
     *             ZERO_SCALED_BY: '[BigDecimal[]]',
     *             HALF_LONG_MAX_VALUE: '[long]',
     *             HALF_LONG_MIN_VALUE: '[long]',
     *             ZERO: '[BigDecimal]',
     *             ONE: '[BigDecimal]',
     *             TEN: '[BigDecimal]',
     *             ROUND_UP: '[int]',
     *             ROUND_DOWN: '[int]',
     *             ROUND_CEILING: '[int]',
     *             ROUND_FLOOR: '[int]',
     *             ROUND_HALF_UP: '[int]',
     *             ROUND_HALF_DOWN: '[int]',
     *             ROUND_HALF_EVEN: '[int]',
     *             ROUND_UNNECESSARY: '[int]',
     *             double10pow: '[double[]]',
     *             float10pow: '[float[]]',
     *             LONG_TEN_POWERS_TABLE: '[long[]]',
     *             BIG_TEN_POWERS_TABLE: '[BigInteger[]]',
     *             BIG_TEN_POWERS_TABLE_INITLEN: '[int]',
     *             BIG_TEN_POWERS_TABLE_MAX: '[int]',
     *             THRESHOLDS_TABLE: '[long[]]',
     *             DIV_NUM_BASE: '[long]',
     *             LONGLONG_TEN_POWERS_TABLE: '[long[][]]',
     *             $assertionsDisabled: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    TicketService_enablePresaleForTicketType(ticketTypeId, presaleStart, presaleEnd, presalePrice) {
        return this.apiClient.invoke('TicketService', 'enablePresaleForTicketType', { ticketTypeId: ticketTypeId, presaleStart: presaleStart, presaleEnd: presaleEnd, presalePrice: presalePrice });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    TicketService_getMyInvoices(eventId) {
        return this.apiClient.invoke('TicketService', 'getMyInvoices', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     void
     */
    TicketService_createTicketReferenceSeriesIfNotExist() {
        return this.apiClient.invoke('TicketService', 'createTicketReferenceSeriesIfNotExist', {  });
    }

    /**
     * Parameter dto:
     *     purchaseInDoorDto: 
     *         {
     *             ticketBuyerPersonId: '[PersonId]',
     *             seatId: '[SeatId]',
     *             discountCouponId: '[Optional]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    TicketService_purchaseInDoor(purchaseInDoorDto) {
        return this.apiClient.invoke('TicketService', 'purchaseInDoor', { purchaseInDoorDto: purchaseInDoorDto });
    }

    /**
     * Parameter dto:
     *     ticketId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         ticketId: '[TicketId]',
     *         ticketTypeId: '[TicketTypeId]',
     *         ticketTypeName: '[String]',
     *         ticketOwner: '[PersonId]',
     *         notes: {
     *             author: '[PersonId]',
     *             createdDateTime: '[Instant]',
     *             note: '[String]'
     *         },
     *         seatId: '[SeatId]',
     *         ticketStatus: '[TicketStatus]'
     *     }
     */
    TicketService_getTicketDetails(ticketId) {
        return this.apiClient.invoke('TicketService', 'getTicketDetails', { ticketId: ticketId });
    }

    /**
     * Parameter dto:
     *     name: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     eventId: 
     *         {

     *         }
     *     bigDecimal: 
     *         {
     *             intVal: '[BigInteger]',
     *             scale: '[int]',
     *             precision: '[int]',
     *             stringCache: '[String]',
     *             INFLATED: '[long]',
     *             INFLATED_BIGINT: '[BigInteger]',
     *             intCompact: '[long]',
     *             MAX_COMPACT_DIGITS: '[int]',
     *             serialVersionUID: '[long]',
     *             threadLocalStringBuilderHelper: '[ThreadLocal]',
     *             zeroThroughTen: '[BigDecimal[]]',
     *             ZERO_SCALED_BY: '[BigDecimal[]]',
     *             HALF_LONG_MAX_VALUE: '[long]',
     *             HALF_LONG_MIN_VALUE: '[long]',
     *             ZERO: '[BigDecimal]',
     *             ONE: '[BigDecimal]',
     *             TEN: '[BigDecimal]',
     *             ROUND_UP: '[int]',
     *             ROUND_DOWN: '[int]',
     *             ROUND_CEILING: '[int]',
     *             ROUND_FLOOR: '[int]',
     *             ROUND_HALF_UP: '[int]',
     *             ROUND_HALF_DOWN: '[int]',
     *             ROUND_HALF_EVEN: '[int]',
     *             ROUND_UNNECESSARY: '[int]',
     *             double10pow: '[double[]]',
     *             float10pow: '[float[]]',
     *             LONG_TEN_POWERS_TABLE: '[long[]]',
     *             BIG_TEN_POWERS_TABLE: '[BigInteger[]]',
     *             BIG_TEN_POWERS_TABLE_INITLEN: '[int]',
     *             BIG_TEN_POWERS_TABLE_MAX: '[int]',
     *             THRESHOLDS_TABLE: '[long[]]',
     *             DIV_NUM_BASE: '[long]',
     *             LONGLONG_TEN_POWERS_TABLE: '[long[][]]',
     *             $assertionsDisabled: '[boolean]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    TicketService_addTicketType(name, eventId, bigDecimal) {
        return this.apiClient.invoke('TicketService', 'addTicketType', { name: name, eventId: eventId, bigDecimal: bigDecimal });
    }

    /**
     * Parameter dto:
     *     personIds: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    GetPersonDetailsQueryHandler_getPersonDetailsBulk(personIds) {
        return this.apiClient.invoke('GetPersonDetailsQueryHandler', 'getPersonDetailsBulk', { personIds: personIds });
    }

    /**
     * Parameter dto:
     *     personId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         id: '[PersonId]',
     *         firstName: '[String]',
     *         lastName: '[String]',
     *         nickname: '[String]',
     *         birthDate: '[LocalDate]',
     *         email: '[String]',
     *         address: '[AddressDto]',
     *         phoneNumber: '[PhoneNumberDto]',
     *         guardian: '[Optional]',
     *         createdOn: '[LocalDate]'
     *     }
     */
    GetPersonDetailsQueryHandler_getPersonDetails(personId) {
        return this.apiClient.invoke('GetPersonDetailsQueryHandler', 'getPersonDetails', { personId: personId });
    }

    /**
     * Parameter dto:
     *     userId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         EMPTY: '[Optional]',
     *         value: '[Object]'
     *     }
     */
    GetPersonDetailsQueryHandler_getPersonDetailsByUserId(userId) {
        return this.apiClient.invoke('GetPersonDetailsQueryHandler', 'getPersonDetailsByUserId', { userId: userId });
    }

    /**
     * Parameter dto:
     *     roleId: 
     *         {

     *         }
     *     userId: 
     *         {

     *         }
     *     permissionArguments: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_grantRoleToUserWithJavaArgs(roleId, userId, permissionArguments) {
        return this.apiClient.invoke('LocalPermissionService', 'grantRoleToUserWithJavaArgs', { roleId: roleId, userId: userId, permissionArguments: permissionArguments });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getAllRoles() {
        return this.apiClient.invoke('LocalPermissionService', 'getAllRoles', {  });
    }

    /**
     * Parameter dto:
     *     roleId: 
     *         {

     *         }
     *     permission: 
     *         {
     *             id: '[String]'
     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_addPermissionToRole(roleId, permission) {
        return this.apiClient.invoke('LocalPermissionService', 'addPermissionToRole', { roleId: roleId, permission: permission });
    }

    /**
     * Parameter dto:
     *     roleId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         name: '[String]',
     *         permissions: {
     *             permissionType: '[PermissionTypeDto]',
     *             hasPermission: '[boolean]'
     *         }
     *     }
     */
    LocalPermissionService_getRoleWithPermissions(roleId) {
        return this.apiClient.invoke('LocalPermissionService', 'getRoleWithPermissions', { roleId: roleId });
    }

    /**
     * Parameter dto:
     *     roleId: 
     *         {

     *         }
     *     role: 
     *         {
     *             name: '[String]',
     *             permissions: {
     *                 permissionType: '[PermissionTypeDto]',
     *                 hasPermission: '[boolean]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_setRolePermissions(roleId, role) {
        return this.apiClient.invoke('LocalPermissionService', 'setRolePermissions', { roleId: roleId, role: role });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             permissionArgumentTypes: {
     *                 id: '[String]'
     *             }
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getPermissionArgumentOptions(query) {
        return this.apiClient.invoke('LocalPermissionService', 'getPermissionArgumentOptions', { query: query });
    }

    /**
     * Parameter dto:
     *     userId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         id: '[UserId]',
     *         grants: {
     *             grantId: '[GrantId]',
     *             roleId: '[RoleId]',
     *             roleName: '[String]',
     *             arguments: {
     *                 argumentType: '[PermissionArgumentType]',
     *                 argumentValue: '[String]'
     *             }
     *         }
     *     }
     */
    LocalPermissionService_getUserWithGrants(userId) {
        return this.apiClient.invoke('LocalPermissionService', 'getUserWithGrants', { userId: userId });
    }

    /**
     * Parameter dto:
     *     grantId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_revokeGrant(grantId) {
        return this.apiClient.invoke('LocalPermissionService', 'revokeGrant', { grantId: grantId });
    }

    /**
     * Parameter dto:
     *     uuid: 
     *         {
     *             serialVersionUID: '[long]',
     *             mostSigBits: '[long]',
     *             leastSigBits: '[long]',
     *             $assertionsDisabled: '[boolean]'
     *         }
     * Return dto:
     *     {
     *         permissions: '[Map]'
     *     }
     */
    LocalPermissionService_getClaims(uuid) {
        return this.apiClient.invoke('LocalPermissionService', 'getClaims', { uuid: uuid });
    }

    /**
     * Parameter dto:
     *     roleId: 
     *         {

     *         }
     *     userId: 
     *         {

     *         }
     *     permissionArguments: 
     *         {
     *             permissionArguments: '[Set]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_grantRoleToUser(roleId, userId, permissionArguments) {
        return this.apiClient.invoke('LocalPermissionService', 'grantRoleToUser', { roleId: roleId, userId: userId, permissionArguments: permissionArguments });
    }

    /**
     * Parameter dto:
     *     name: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_createRole(name) {
        return this.apiClient.invoke('LocalPermissionService', 'createRole', { name: name });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_createAuthenticatedUserRole() {
        return this.apiClient.invoke('LocalPermissionService', 'createAuthenticatedUserRole', {  });
    }

    /**
     * Parameter dto:
     *     userId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_newUserWasCreated(userId) {
        return this.apiClient.invoke('LocalPermissionService', 'newUserWasCreated', { userId: userId });
    }

    /**
     * Parameter dto:
     *     roleId: 
     *         {

     *         }
     *     name: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_createRoleWithId(roleId, name) {
        return this.apiClient.invoke('LocalPermissionService', 'createRoleWithId', { roleId: roleId, name: name });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getAllUsers() {
        return this.apiClient.invoke('LocalPermissionService', 'getAllUsers', {  });
    }

    /**
     * Parameter dto:
     *     userId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         userId: '[UserId]',
     *         name: '[String]'
     *     }
     */
    LocalPermissionService_getUserDetails(userId) {
        return this.apiClient.invoke('LocalPermissionService', 'getUserDetails', { userId: userId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         permissions: '[Map]'
     *     }
     */
    LocalPermissionService_getMyClaims() {
        return this.apiClient.invoke('LocalPermissionService', 'getMyClaims', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getPermissions() {
        return this.apiClient.invoke('LocalPermissionService', 'getPermissions', {  });
    }

    /**
     * Parameter dto:
     *     checkinBySeatNumberQuery: 
     *         {
     *             seatNumber: '[String]',
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         EMPTY: '[Optional]',
     *         value: '[Object]'
     *     }
     */
    CheckInBySeatNumberQueryHandler_query(checkinBySeatNumberQuery) {
        return this.apiClient.invoke('CheckInBySeatNumberQueryHandler', 'query', { checkinBySeatNumberQuery: checkinBySeatNumberQuery });
    }

    /**
     * Parameter dto:
     *     creditCardPaymentId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         creditCardPaymentId: '[CreditCardPaymentId]',
     *         stripeChargeStatus: '[StripeChargeStatus]',
     *         exceptionMessage: '[String]'
     *     }
     */
    PurchaseWithCreditCardCommandHandler_retryCreditCardCharge(creditCardPaymentId) {
        return this.apiClient.invoke('PurchaseWithCreditCardCommandHandler', 'retryCreditCardCharge', { creditCardPaymentId: creditCardPaymentId });
    }

    /**
     * Parameter dto:
     *     purchaseDto: 
     *         {
     *             seatIds: {

     *             },
     *             cardToken: '[String]',
     *             discountCouponIds: {

     *             }
     *         }
     * Return dto:
     *     {
     *         creditCardPaymentId: '[CreditCardPaymentId]',
     *         stripeChargeStatus: '[StripeChargeStatus]',
     *         exceptionMessage: '[String]'
     *     }
     */
    PurchaseWithCreditCardCommandHandler_purchase(purchaseDto) {
        return this.apiClient.invoke('PurchaseWithCreditCardCommandHandler', 'purchase', { purchaseDto: purchaseDto });
    }

    /**
     * Parameter dto:
     *     checkInWristBandCommand: 
     *         {
     *             personId: '[PersonId]',
     *             wristBandNumber: '[String]',
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     void
     */
    CheckInWristBandCommandHandler_handle(checkInWristBandCommand) {
        return this.apiClient.invoke('CheckInWristBandCommandHandler', 'handle', { checkInWristBandCommand: checkInWristBandCommand });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             ticketId: '[TicketId]',
     *             currentOwner: '[PersonId]',
     *             ticketStatus: '[TicketStatus]',
     *             ticketTypeId: '[TicketTypeId]',
     *             ticketTypeName: '[String]',
     *             seatDto: '[Optional]'
     *         }
     *     }
     */
    GetAllTicketsQueryHandler_handle(query) {
        return this.apiClient.invoke('GetAllTicketsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             participantId: '[ParticipantId]',
     *             wristBandNumber: '[String]',
     *             personId: '[PersonId]',
     *             status: '[ParticipantStatus]',
     *             seatNumbers: {
     *                 value: '[char[]]',
     *                 hash: '[int]',
     *                 serialVersionUID: '[long]',
     *                 serialPersistentFields: '[ObjectStreamField[]]',
     *                 CASE_INSENSITIVE_ORDER: '[Comparator]'
     *             }
     *         }
     *     }
     */
    GetAllParticipantsQueryHandler_query(query) {
        return this.apiClient.invoke('GetAllParticipantsQueryHandler', 'query', { query: query });
    }

    /**
     * Parameter dto:
     *     personDetailsDto: 
     *         {
     *             id: '[PersonId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             nickname: '[String]',
     *             birthDate: '[LocalDate]',
     *             email: '[String]',
     *             address: '[AddressDto]',
     *             phoneNumber: '[PhoneNumberDto]',
     *             guardian: '[Optional]',
     *             createdOn: '[LocalDate]'
     *         }
     * Return dto:
     *     void
     */
    EditPersonCommandHandler_editPerson(personDetailsDto) {
        return this.apiClient.invoke('EditPersonCommandHandler', 'editPerson', { personDetailsDto: personDetailsDto });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         rows: {
     *             seats: {
     *                 seatId: '[SeatId]',
     *                 seatNumber: '[String]',
     *                 isSpace: '[boolean]',
     *                 seatHolder: '[TicketId]',
     *                 ticketTypeId: '[TicketTypeId]',
     *                 currentOwner: '[PersonId]',
     *                 seatStatus: '[SeatStatus]'
     *             }
     *         }
     *     }
     */
    SeatingService_getSeatMap(eventId) {
        return this.apiClient.invoke('SeatingService', 'getSeatMap', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     ticketBuyerPersonId: 
     *         {

     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    SeatingService_getSeatsReservedByPerson(ticketBuyerPersonId, eventId) {
        return this.apiClient.invoke('SeatingService', 'getSeatsReservedByPerson', { ticketBuyerPersonId: ticketBuyerPersonId, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     ticketId: 
     *         {

     *         }
     *     toSeatId: 
     *         {

     *         }
     * Return dto:
     *     void
     */
    SeatingService_switchSeat(ticketId, toSeatId) {
        return this.apiClient.invoke('SeatingService', 'switchSeat', { ticketId: ticketId, toSeatId: toSeatId });
    }

    /**
     * Parameter dto:
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         totalSeatCount: '[int]',
     *         reservedSeatCount: '[int]'
     *     }
     */
    SeatingService_getSeatCount(eventId) {
        return this.apiClient.invoke('SeatingService', 'getSeatCount', { eventId: eventId });
    }

    /**
     * Parameter dto:
     *     ticketTypeId: 
     *         {

     *         }
     *     seatNumber: 
     *         {
     *             value: '[char[]]',
     *             hash: '[int]',
     *             serialVersionUID: '[long]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]'
     *         }
     *     eventId: 
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    SeatingService_createSeat(ticketTypeId, seatNumber, eventId) {
        return this.apiClient.invoke('SeatingService', 'createSeat', { ticketTypeId: ticketTypeId, seatNumber: seatNumber, eventId: eventId });
    }

    /**
     * Parameter dto:
     *     seatId: 
     *         {

     *         }
     * Return dto:
     *     {
     *         seatId: '[SeatId]',
     *         seatNumber: '[String]',
     *         seatHolder: '[TicketId]',
     *         ticketType: '[TicketTypeDto]',
     *         unavailableForSale: '[boolean]'
     *     }
     */
    SeatingService_getSeatDetails(seatId) {
        return this.apiClient.invoke('SeatingService', 'getSeatDetails', { seatId: seatId });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             name: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    SearchPersonByNameQueryHandler_query(query) {
        return this.apiClient.invoke('SearchPersonByNameQueryHandler', 'query', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    GetAllPersonsQueryHandler_getAll() {
        return this.apiClient.invoke('GetAllPersonsQueryHandler', 'getAll', {  });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             id: '[DiscountCouponId]',
     *             code: '[String]',
     *             description: '[String]',
     *             discountAmount: '[BigDecimal]',
     *             validFromDate: '[Optional]',
     *             validToDate: '[Optional]',
     *             maxNumberOfUses: '[int]',
     *             numberOfUses: '[int]',
     *             valid: '[boolean]'
     *         }
     *     }
     */
    GetAllDiscountCouponsQueryHandler_execute(query) {
        return this.apiClient.invoke('GetAllDiscountCouponsQueryHandler', 'execute', { query: query });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {

     *         }
     * Return dto:
     *     {
     *         id: '[EventId]',
     *         name: '[String]',
     *         ageLimit: '[int]',
     *         startDate: '[LocalDate]',
     *         endDate: '[LocalDate]',
     *         venue: '[VenueDto]'
     *     }
     */
    GetActiveEventQueryHandler_handle(query) {
        return this.apiClient.invoke('GetActiveEventQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     arg0: 
     *         {

     *         }
     * Return dto:
     *     {
     *         userId: '[UserId]',
     *         name: '[String]'
     *     }
     */
    UserProvider_getUserDto(arg0) {
        return this.apiClient.invoke('UserProvider', 'getUserDto', { arg0: arg0 });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    UserProvider_getAllUserIds() {
        return this.apiClient.invoke('UserProvider', 'getAllUserIds', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    UserProvider_getUserDtos() {
        return this.apiClient.invoke('UserProvider', 'getUserDtos', {  });
    }

    /**
     * Parameter dto:
     *     command: 
     *         {
     *             ticketId: '[TicketId]',
     *             newOwner: '[PersonId]',
     *             resetTicketFromCheckedInToPaidIfNecessary: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    TransferTicketCommandHandler_handle(command) {
        return this.apiClient.invoke('TransferTicketCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    CommunicationsService_getAllSentEmails() {
        return this.apiClient.invoke('CommunicationsService', 'getAllSentEmails', {  });
    }

    /**
     * Parameter dto:
     *     personDto: 
     *         {
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             birthDate: '[LocalDate]',
     *             email: '[String]',
     *             address: '[AddressDto]',
     *             phoneNumber: '[PhoneNumberDto]',
     *             guardian: '[GuardianDto]',
     *             nickname: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    AccessAndIdentityService_registerPerson(personDto) {
        return this.apiClient.invoke('AccessAndIdentityService', 'registerPerson', { personDto: personDto });
    }

    /**
     * Parameter dto:
     *     seatId: 
     *         {

     *         }
     *     discountCouponId: 
     *         {
     *             EMPTY: '[Optional]',
     *             value: '[Object]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    PurchaseTicketCommandHandler_purchase(seatId, discountCouponId) {
        return this.apiClient.invoke('PurchaseTicketCommandHandler', 'purchase', { seatId: seatId, discountCouponId: discountCouponId });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             discountCode: '[String]',
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         EMPTY: '[Optional]',
     *         value: '[Object]'
     *     }
     */
    GetDiscountCouponByCodeQueryHandler_execute(query) {
        return this.apiClient.invoke('GetDiscountCouponByCodeQueryHandler', 'execute', { query: query });
    }

    /**
     * Parameter dto:
     *     arg0: 
     *         {
     *             id: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    PermissionArgumentOptionService_getOptions(arg0) {
        return this.apiClient.invoke('PermissionArgumentOptionService', 'getOptions', { arg0: arg0 });
    }

    /**
     * Parameter dto:
     *     query: 
     *         {
     *             ticketReference: '[String]',
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     {
     *         EMPTY: '[Optional]',
     *         value: '[Object]'
     *     }
     */
    CheckInByTicketReferenceQueryHandler_query(query) {
        return this.apiClient.invoke('CheckInByTicketReferenceQueryHandler', 'query', { query: query });
    }

    /**
     * Parameter dto:
     *     replaceWristBandCommand: 
     *         {
     *             eventId: '[EventId]',
     *             newWristBandNumber: '[String]',
     *             personId: '[PersonId]'
     *         }
     * Return dto:
     *     void
     */
    ReplaceWristBandCommandHandler_handle(replaceWristBandCommand) {
        return this.apiClient.invoke('ReplaceWristBandCommandHandler', 'handle', { replaceWristBandCommand: replaceWristBandCommand });
    }

    /**
     * Parameter dto:
     *     createDiscountCouponCommand: 
     *         {
     *             code: '[String]',
     *             description: '[String]',
     *             discountAmount: '[BigDecimal]',
     *             validFromDate: '[Optional]',
     *             validToDate: '[Optional]',
     *             maxNumberOfUses: '[int]',
     *             eventId: '[EventId]'
     *         }
     * Return dto:
     *     void
     */
    CreateDiscountCouponCommandHandler_handle(createDiscountCouponCommand) {
        return this.apiClient.invoke('CreateDiscountCouponCommandHandler', 'handle', { createDiscountCouponCommand: createDiscountCouponCommand });
    }
}
